function e() {
  return typeof window < "u" && typeof document < "u";
}
export {
  e as isClient
};
